import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "field_gap_report_filters"

export default class extends Controller {
  connect() {
    // Skip cache preview renders (Turbo sets this attribute while showing
    // a cached snapshot before the real response arrives)
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    const hasParams = window.location.search.length > 1

    if (hasParams) {
      localStorage.setItem(STORAGE_KEY, window.location.search)
    } else {
      try {
        const saved = localStorage.getItem(STORAGE_KEY)
        if (saved && saved.length > 1) {
          Turbo.visit(window.location.pathname + saved, { action: "replace" })
        }
      } catch (_) {}
    }
  }

  clear() {
    localStorage.removeItem(STORAGE_KEY)
  }
}
